jQuery(document).ready(function ($) {
    $('#pa_color').on('change', function (e) {
        if ($('.woocommerce-product-gallery').length <= 1) {
            // skip if only one gallery (i.e., the "attribute-all" gallery) exists
            return;
        }

        var current_attr_slug = $(this).val();
        if (!current_attr_slug) {
            current_attr_slug = 'all';
        }
        $('.woocommerce-product-gallery').addClass('gallery-hidden');
        $('.product-thumbnails').addClass('thumbnails-slider-hidden');
        $('.woocommerce-product-gallery.attribute-' + current_attr_slug).removeClass('gallery-hidden');
        // resize to reinitialize the flickety slider after making it visible
        $('.product-thumbnails.attribute-' + current_attr_slug).removeClass('thumbnails-slider-hidden')
            .flickity('resize');
    });

    setTimeout(function (e) {
        //select gallery given by GET-parameters => otherwise take default
        var get_params = new URLSearchParams(location.search);
        var selected_color = get_params.get("color");
        if (!selected_color) {
            selected_color = $('#default_attribute_gallery').data('attribute-slug');
        }
        var click_element = false;
        if (selected_color) {
            var element = $('.add-to-cart-container .ux-swatches .swatch-' + selected_color + ' .ux-swatch__color');
            click_element = element.length === 1 ? element : click_element;
        }
        if (!click_element) {// select first color
            var elements = $('.add-to-cart-container .ux-swatches-attribute-ux_color .ux-swatch');
            click_element = elements.length > 0 ? elements.get(0) : click_element;
        }
        if (click_element) {
            click_element.click();
        }
    }, 100);
});
